// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * A single risk's coverage in a build (TCV-6726).
 * @export
 * @interface BuildRiskCoverageItem
 */
export interface BuildRiskCoverageItem {
  /**
   *
   * @type {number}
   * @memberof BuildRiskCoverageItem
   */
  id: number;
  /**
   * Per-company business number of the risk (rendered as RSK-<n>).
   * @type {number}
   * @memberof BuildRiskCoverageItem
   */
  displayNumber?: number;
  /**
   *
   * @type {string}
   * @memberof BuildRiskCoverageItem
   */
  title: string;
  /**
   * Exposure band of the risk.
   * @type {string}
   * @memberof BuildRiskCoverageItem
   */
  exposureBand: BuildRiskCoverageItemExposureBandEnum;
  /**
   * Distinct linked test cases executed against this build.
   * @type {number}
   * @memberof BuildRiskCoverageItem
   */
  casesRun: number;
  /**
   * True when at least one linked test case was executed against this build.
   * @type {boolean}
   * @memberof BuildRiskCoverageItem
   */
  covered: boolean;
}

export function BuildRiskCoverageItemFromJSON(
  json: any
): BuildRiskCoverageItem {
  return {
    id: json["id"],
    displayNumber: !exists(json, "display_number")
      ? undefined
      : json["display_number"],
    title: json["title"],
    exposureBand: json["exposure_band"],
    casesRun: json["cases_run"],
    covered: json["covered"],
  };
}

export function BuildRiskCoverageItemToJSON(
  value?: BuildRiskCoverageItem
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    display_number: value.displayNumber,
    title: value.title,
    exposure_band: value.exposureBand,
    cases_run: value.casesRun,
    covered: value.covered,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum BuildRiskCoverageItemExposureBandEnum {
  Low = "low",
  Medium = "medium",
  High = "high",
  Critical = "critical",
}
